'use client';

import { useEffect, useRef } from 'react';
import { trackEvent } from '@/lib/analytics/counterscale';

/* Fires `event` once per page load when this point scrolls into view. Lets a
   low click count on a lower section be read correctly: "seen and ignored"
   vs "never reached". Absolutely positioned at its place in the flow, so it
   takes no flex/grid slot and adds no gap. */
export function SeenMarker({ event }: { event: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        trackEvent(event);
        io.disconnect();
      }
    });
    io.observe(el);
    return () => io.disconnect();
  }, [event]);
  return (
    <span
      ref={ref}
      aria-hidden
      style={{ position: 'absolute', width: 1, height: 1 }}
    />
  );
}
